export default "__VITE_PUBLIC_ASSET__03fcf07b__"